import { ChatOpenAI } from "@langchain/openai";
import { getAuthHeader } from "../../lib/authFetch";

const ORIGIN =
  process.env.NODE_ENV === "development"
    ? "http://localhost:5000"
    : window.location.origin;

export const LLM_PROVIDERS = [
  { value: "openai", label: "ChatGPT" },
  { value: "anthropic", label: "Claude" },
];

const PROVIDER_CONFIG = {
  openai: { modelName: "gpt-5", baseURL: `${ORIGIN}/openai/v1` },
  // Routed through Anthropic's OpenAI-compatible endpoint
  // (https://platform.claude.com/docs/en/cli-sdks-libraries/libraries/openai-sdk),
  // proxied server-side just like the OpenAI route.
  anthropic: { modelName: "claude-opus-5", baseURL: `${ORIGIN}/anthropic/v1` },
};

export async function getChatModel(provider = "openai") {
  const { modelName, baseURL } = PROVIDER_CONFIG[provider] || PROVIDER_CONFIG.openai;
  const authHeader = await getAuthHeader();

  const llm = new ChatOpenAI({
    openAIApiKey: "proxied",
    temperature: 1,
    modelName,
    configuration: { baseURL, defaultHeaders: authHeader },
  });

  if (provider === "anthropic") {
    // Claude's OpenAI-compatible endpoint rejects top_p as deprecated for
    // Claude 5 models, and doesn't support frequency/presence penalties.
    // ChatOpenAI sends these by default, so clear them here.
    llm.topP = undefined;
    llm.frequencyPenalty = undefined;
    llm.presencePenalty = undefined;
  }

  return llm;
}
